export default "__VITE_ASSET__D1MccXeZ__"